var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('b-modal',{ref:"modal",attrs:{"scrollable":"","id":"qr-code","header-class":"headerModal","centered":"","title":"","hide-footer":"","hide-header":""}},[_c('qrcode-vue',{attrs:{"value":_vm.selectedMaterialVariant,"size":460,"level":"H"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }